/**
 * Health API Service
 * Handles health checks and utility endpoints
 */

export class HealthService {
  constructor(apiClient, errorHandler) {
    this.apiClient = apiClient;
    this.handleApiError = errorHandler;
  }

  /**
   * Get health status of the API
   * @returns {Promise<Object>} Health status
   */
  async getHealthStatus() {
    try {
      const response = await this.apiClient.get('/health');
      return response.data;
    } catch (error) {
      console.error('Error getting health status:', error);
      throw this.handleApiError(error);
    }
  }

  /**
   * Get API version information
   * @returns {Promise<Object>} Version information
   */
  async getVersion() {
    try {
      // /health/ returns { status, service, version, timestamp } — no separate /version route
      const response = await this.apiClient.get('/health/');
      return response.data;
    } catch (error) {
      console.error('Error getting version:', error);
      throw this.handleApiError(error);
    }
  }

  /**
   * Ping the API to check connectivity
   * @returns {Promise<Object>} Ping response
   */
  async ping() {
    try {
      // /health/ready is the readiness probe — no separate /ping route
      const response = await this.apiClient.get('/health/ready');
      return response.data;
    } catch (error) {
      console.error('Error pinging API:', error);
      throw this.handleApiError(error);
    }
  }
}

export default HealthService;